module.exports = __webpack_public_path__ + "media/images/home/required_docs@2x-596e091fa06ee4bc01cd8bf21172a0c7.png";